import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useActionCardStyles } from './action-card.styles';

interface ActionCardProps {
  title: string;
  description: string;
  buttonText: string;
  onButtonClick: () => void;
}

export const ActionCard = (props: ActionCardProps) => {
  // Props
  const { title, description, buttonText, onButtonClick } = props;

  // Component Styles
  const classes = useActionCardStyles();

  return (
    <Box className={classes.cardContainer}>
      <Box className={classes.contentContainer}>
        <Typography className={classes.cardTitle}>{title}</Typography>
        <Typography className={classes.cardDescription}>
          {description}
        </Typography>
      </Box>
      <Typography className={classes.cardAction} onClick={onButtonClick}>
        {buttonText}
      </Typography>
    </Box>
  );
};
